
(function ($, root, undefined) {

	$(function () {
		'use strict';

    // Init AOS
    AOS.init();

    // Scroll to top
    var btn = $('#button');
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });

    // Scroll to anchor
    var $root = $('html, body');
    $('a[href^="#"]').click(function() {
      if($(this).hasClass('.anchor-link')) {
        var href = $.attr(this, 'href');
        $root.animate({scrollTop: $(href).offset().top}, 500, function() {
          window.location.hash = href;
        });
        return false;
      }
    });

    // Fonction fixe navigation
    fixeNav();

    function fixeNav() {
      var lastScrollTop = 0;
      var threshold = 200;

      $(window).scroll(function(event){
        var currentScrollTop = $(this).scrollTop();

        if (lastScrollTop < threshold){
          $('.bkgHeader').removeClass("stickcolored");
        } else {
          $('.bkgHeader').addClass("stickcolored");
        }

        if (currentScrollTop > lastScrollTop && lastScrollTop > threshold){
          $('.header').addClass("stickhidden");
        } else {
          $('.header').removeClass("stickhidden");
        }

        lastScrollTop = currentScrollTop;
      });
    }

    dropDownMobile();

    function dropDownMobile() {
      // Toogle Navigation Mobile
      $('.mobile-menu__item').click(function(){
        //Expand or collapse this panel
        $(".menu-item-has-children").not($(this)).removeClass('active');
        $(this).toggleClass('active');
      });
    }

    // SubMenu Navigation
    subMenuToggle();

    function subMenuToggle() {

      const menuH = $('.desktop-menu').outerHeight();

      $('.desktop-menu .menu-item-has-children').mouseenter(
        function(){

          if(!$(this).hasClass('active')){
            $('.desktop-menu .menu-item-has-children.active .sub-menu').stop().animate({ top: '-'+(menuH+200)+'px'}, 300, function() { });
            $(this).addClass('active');

            const subMenu = $(this).find('.sub-menu');
            $(subMenu).stop().animate({ top: menuH+'px'}, 400, function() { });
          }
        }
      );

      $(".desktop-menu .menu-item-has-children").mouseleave(function(){
        console.log('mouseleave');
        if($(this).hasClass('active')){
          $('.menu-item-has-children.active .sub-menu').stop().animate({ top: '-'+(menuH+200)+'px'}, 300, function() { });
          $(this).removeClass('active');
        }
      });
    }

    if($('.movableCursor').length){
      gsap.registerPlugin(ScrollTrigger);
      movableCursorElem();
    }

    function movableCursorElem(){

      const throttled = (delay, fn) => {
        let lastCall = 0;
        return function (...args) {
          const now = (new Date()).getTime();
          if (now - lastCall < delay) {
            return;
          }
          lastCall = now;
          return fn(...args);
        };
      };
    
      const movableElementsWrapper = document.querySelector('body');
    
      // const mouseMoveHandler = (e) => {
      //       const y = e.movementY;
      //       const x = e.movementX;
        
      //       let moveX = x > 0 ? -x : x;
      //       let moveY = y > 0 ? -y : y;
    
      //       const movableElements =   document.querySelectorAll('.movableCursor');
    
      //       movableElements.forEach(
      //         (movableElement) => {
      //           gsap.to(movableElement, {x: moveX, y: moveY, duration: 1});
      //         }
      //       );
      //   };
      // const speed = 0.35;
    
      const mouseMoveHandler2 = (e) => {
        const movableElements =   document.querySelectorAll('.movableCursor');
    
        movableElements.forEach(
          (movableElement) => {
            const  shiftValue = 3;
            const moveX = (e.clientX * shiftValue) / 250;
            const moveY = (e.clientY * shiftValue) / 250;
            
            
            gsap.to(movableElement, {x: moveX, y: moveY, duration: 1});
    
          }
        );
      };
    
      const tHandler = throttled(200, mouseMoveHandler2);
      movableElementsWrapper.onmousemove = tHandler;
    
    
    }

	});

})(jQuery, this);


